import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";

function SvgPhone(props) {
  return _jsxs("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: [_jsx("path", {
      d: "M37.828 14.703c5.07 1.043 9.033 5.224 10.023 10.57M37.828 4C48.433 5.242 56.808 14.064 58 25.246",
      stroke: "#FF6652",
      strokeWidth: 3,
      strokeLinecap: "round"
    }, void 0), _jsx("path", {
      clipRule: "evenodd",
      d: "M56.463 46.6v8.027c.006 1.506-.591 2.946-1.644 3.965-1.053 1.019-2.465 1.522-3.888 1.386-7.807-.894-15.307-3.708-21.897-8.215-6.13-4.108-11.328-9.59-15.224-16.054-4.288-6.981-6.957-14.929-7.79-23.2a5.537 5.537 0 011.307-4.09c.96-1.109 2.318-1.742 3.743-1.743h7.612c2.547-.027 4.718 1.942 5.075 4.602a35.898 35.898 0 001.776 7.52c.697 1.955.25 4.16-1.142 5.645l-3.222 3.399c3.611 6.699 8.871 12.245 15.223 16.055l3.223-3.399c1.409-1.469 3.5-1.939 5.354-1.204a31.207 31.207 0 007.13 1.873c2.551.38 4.428 2.716 4.364 5.432v0z",
      stroke: "#7373FF",
      strokeWidth: 3
    }, void 0)]
  }), void 0);
}

export default SvgPhone;